module.exports = __webpack_public_path__ + "img/start.b99ad477.jpeg";